// A dónde vuelve el huésped después de ingresar: la cancelación o el check-in
// (default). Se recuerda cuando se lo manda al login desde una ruta de
// cancelación (link viejo, botón de arrepentimiento, token vencido o sesión de
// otra reserva) y se consume al ingresar. Sólo guarda "cancel": el CID sale
// siempre de lo que el huésped tipeó y api2 lo valida.
const KEY = "px_login_destination";

export const destinationForPath = path =>
  /\/cancel(\/|$)/.test(path || "") ? "cancel" : "checkin";

export const rememberLoginDestination = path => {
  try {
    if (destinationForPath(path) === "cancel") sessionStorage.setItem(KEY, "cancel");
    else sessionStorage.removeItem(KEY);
  } catch (e) {
    // sin sessionStorage: después del login se va al check-in
  }
};

export const peekLoginDestination = () => {
  try {
    return sessionStorage.getItem(KEY) === "cancel" ? "cancel" : "checkin";
  } catch (e) {
    return "checkin";
  }
};

export const takeLoginDestination = () => {
  const destination = peekLoginDestination();
  try {
    sessionStorage.removeItem(KEY);
  } catch (e) {
    // nada que limpiar
  }
  return destination;
};
